import styled from "@emotion/styled";
import { Card, CardContent, css } from "@mui/material";

export const GridData = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;

  gap: 10px;
  a {
    text-decoration: none;
    color: inherit;
  }
  > div {
    border-radius: 30px;
    text-align: center;
  }
`;

export const StyledCard = styled(Card)`
  height: 300px;
  width: 300px;
  color: #114c97;
  transition: 0.5s;
  box-shadow: 0px 3px 6px #00000029;
  filter: grayscale(100%);
  ${(props) =>
    props.estado !== "deshabilitado" &&
    css`
      filter: grayscale(0%);
      :hover {
        transition: 0.5s;
        background-color: #114c97;
        color: floralwhite;
        cursor: pointer;
      }
    `}
  img {
    aspect-ratio: 1;
    object-fit: contain;
    transition: 0.25s;
  }

  img.enable:hover {
    transform: scale(1.1);
  }
`;
export const StyledCardContent = styled(CardContent)`
  display: flex;
  height: 80%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
